/* *@description: 批量上传组件 */
<template>
  <div
    ref="RemarkUpload"
    :class="uploadTips ? 'pathsBorder' : ''"
    @paste.stop="onPaste"
    @mouseenter.stop="onMouseenter"
    @mouseleave.stop="onMouseleave"
  >
    <span class="uploadTips" v-if="uploadTips">{{
      $lang("可直接复制粘贴或拖拽附件上传")
    }}</span>
    <div class="img_box">
      <div
        class="img_size"
        v-for="(item, index) of fileListResAll"
        :key="index"
        v-show="fileListResAll.length !== 0"
      >
        <!-- 图片预览 -->
        <img
          v-if="getFileTypeIcon(item) === 'hidden'"
          :src="item.downloadUrl"
        />
        <span v-if="getFileTypeIcon(item) !== 'hidden'">
          <i
            :class="'iconfont icon_size ' + getFileTypeIcon(item)"
          ></i>
        </span>
        <!-- 删除 -->
        <span class="close" v-if="!isView" @click="fileDel(index)">
          <svg class="icon svg-icon" aria-hidden="true">
            <use xlink:href="#iconguanbi"></use>
          </svg>
          <!--<i class="iconfont iconwuliao-bohui"
             @click="fileDel(index)"></i>-->
        </span>
        <!--<div class="img-mark">
          <span><i class="el-icon-zoom-in"></i></span>
        </div>-->
        <div class="img-mark">
          <span
            v-if="getFileTypeIcon(item) === 'hidden'"
            @click="showImg(item)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="getFileTypeIcon(item) !== 'hidden'"
            @click="handleDownload(item)"
          >
            <i
              class="iconfont iconcaozuopingtaitubiao_daojiancaozuo"
            ></i>
          </span>
        </div>
      </div>
      <div v-show="isLoadingSuccess" class="loading">
        <i class="icon el-icon-loading"></i>
        <div class="l-text">{{ $lang('上传中...') }}</div>
      </div>
      <!-- 上传 -->
      <div
        class="add_img"
        v-show="currentLimit !== limit && !isView&&!isLoadingSuccess"
        @click="fileClick"
      >
        <i class="el-icon-plus"></i>
      </div>
      <!-- 上传按钮 -->
      <input
        name="files"
        style="display: none"
        @change="fileChange($event)"
        type="file"
        ref="file"
        :multiple="multiple"
        :accept="nameTransformation(fileTypeList)"
      />
    </div>
    <!--<base-image-view v-show="showViewer" :initial-index="imageIndex" :onClose="()=>showViewer = false" :url-list="urlList"></base-image-view>-->
  </div>
</template>

<script>
import fetch from '@/common/utils/serFetch';
// import fetch from '@public/http/request'
// import { RESPONSE_CODE } from '@public/http/config'
import { RESPONSE_CODE } from '../@public/http/config';
import axios from 'axios';
// import { GATEWAY } from '../@public/config/index'
import { imgRegular, imgRegularBase } from '@/common/utils/tool';
export default {
  name: 'BaseBatchUpload',
  data() {
    return {
      imgList: [],
      fileListResAll: [], // 传递的时的数据
      currentLimit: 0, // 当前数量
      showViewer: false,
      urlList: [],
      isLoadingSuccess: false,
      uploadingCount: 0
    };
  },
  props: {
    isAll: Boolean,
    // 配置项
    option: {
      type: Object,
      default() {
        return {
          projectName: '',
          moduleName: '',
          fileNames: ''
        };
      }
    },
    // 数据
    list: {
      type: Array,
      default: () => []
    },
    // 文件大小
    fileSize: {
      type: Number,
      default: () => 5
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: () => 3
    },
    // 上传前回调
    beforeUpload: {
      type: Function,
      default: () => {}
    },
    // 允许上传的文件类型
    fileTypeList: {
      type: Array,
      default: () => [
        'png',
        'pdf',
        'jpg',
        'jpeg',
        'x-zip-compressed'
      ]
    },
    // 是否允许批量上传
    multiple: {
      type: Boolean,
      default: () => false
    },
    // 是否是查看
    isView: {
      type: Boolean,
      default: () => false
    },
    uploadTips: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    list: {
      handler(nVal, oVal) {
        this.fileListResAll = nVal;
        this.currentLimit = this.fileListResAll.length;
      }
    },
    deep: true
  },
  mounted() {
    if (this.uploadTips) {
      const dropBox = this.$refs.RemarkUpload;
      dropBox.addEventListener('dragenter', this.dragEnter, false);
      dropBox.addEventListener('dragover', this.dragOver, false);
      dropBox.addEventListener('drop', this.drop, false);
    }
  },
  created() {
    if (this.list && this.list.length) {
      this.fileListResAll = this.list;
      this.currentLimit = this.fileListResAll.length;
    }
  },
  methods: {
    /**
     * 后缀校验转换
     * @param {*} list
     */
    nameTransformation(list) {
      var newType = this.deepClone(list);
      const typeArr = {
        docx: 'vnd.openxmlformats-officedocument.wordprocessingml.document',
        doc: 'msword',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'x-zip-compressed':
          'application/zip,application/x-zip,application/x-zip-compressed',
        pdf: 'application/pdf',
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        gif: 'image/gif',
        png: 'image/png'
      };
      for (var key in typeArr) {
        var val = newType.indexOf(key);
        val !== -1 && (newType[val] = typeArr[key]);
      }
      return this.isAll ? '*' : newType.join(',');
    },
    /**
     * 判断文件类型ICON
     * @param {*} item 行数据
     */
    getFileTypeIcon(item) {
      const name = (item.path || item.downloadUrl).toLowerCase();
      if (name.match(imgRegular)) {
        return 'hidden';
      }
      if (name.indexOf('.pdf') > -1) {
        return 'iconPDF';
      }
      if (name.indexOf('.docx') > -1) {
        return 'icondocx1';
      }
      if (name.indexOf('.doc') > -1) {
        return 'icondoc1';
      }
      if (name.indexOf('.xls') > -1) {
        return 'icongonggaoguanli-wendang';
      }
      if (name.indexOf('.zip') > -1) {
        return 'iconyasuobao';
      }
      if (name.indexOf('.rar') > -1) {
        return 'iconRAR';
      }
      return 'icongonggaoguanli-wendang';
    },
    /**
     * 上传点击事件
     * @param {*} null
     */
    fileClick() {
      try {
        this.$refs.file.click();
      } catch (err) {
        console.error(err);
      }
    },
    /**
     * 上传监听事件
     * @param {*} el DOM数据
     */
    fileChange(el) {
      // 1.上传前回调
      if (
        this.beforeUpload &&
        typeof this.beforeUpload === 'function'
      ) {
        this.beforeUpload();
      }
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = '';
    },
    handleDownload: function (file) {
      // window.open(file.downloadUrl, file.name)
      const xhr = new XMLHttpRequest();
      xhr.open('GET', file.downloadUrl, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        const url = URL.createObjectURL(xhr.response);
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', decodeURIComponent(file.name));
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
      };
      xhr.send();
    },
    /**
     * 文件处理中转
     * @param {*} fileList
     */
    async fileList(fileList) {
      const files = fileList.files;
      for (let i = 0; i < files.length; i++) {
        // 1. 校验文件规格
        if (this.verifyFun(files[i])) {
          // 2.1 数量增加
          this.currentLimit++;
          this.$emit('uploadStart');
          // 2.2 非文件夹处理 // window rar 为空
          // if (files[i].type !== '') {
          this.fileAdd(files[i]);
          this.uploadFile(files[i]);
          // }
        } else {
          break;
        }
      }
    },
    /**
     * 获取阿里云路径
     * @param {*} null
     */
    async uploadFile(option) {
      console.log('option', option);
      // 1. 请求阿里云接口,获得阿里云上传路径/密钥以及签名
      // const name = option.name.replace(/,/g, '');
      const name = option.name;
      // 处理文件名多余非法字符
      const filterName = name
        .substring(0, name.lastIndexOf('.'))
        .replace(
          /[\ |\~|\`|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\+|\=|\||\\|\[|\]|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?/\，/\。/\；/\：/\“/\”/\》/\《/\|/\{/\}/\、/\!/\~/\`]/g,
          ''
        );
      const suffixName = name.substring(name.lastIndexOf('.'));
      const paramsName = filterName + suffixName;
      const { moduleName, projectName } = this.option;
      const param = {
        projectName: projectName || 'ylbpo',
        moduleName: moduleName || this.$route.name,
        size: option.size,
        fileNames: paramsName
      };
      const uploadApi =
        this.option.uploadApi ||
        `bpo/file/getUploadSignedUrl`;
      const { code, data, msg } = await fetch.get(uploadApi, {
        params: param
      });
      // 2. 异常报错
      if (!code && code !== 0) {
        this.$message.error(
          this.$lang('文件上传功能异常，请联系客服')
        );
        return;
      }
      // 2.1 异常报错
      if (code !== RESPONSE_CODE.SUCCESS_COPY || !data) {
        this.$message.error(
          msg || this.$lang('文件上传功能异常，请联系客服')
        );
        return;
      }
      // 3 处理阿里云上传路径
      const res = {
        ...data[0],
        contentType: data[0].contentType,
        url: data[0].url.replace('http:', window.location.protocol),
        config: { headers: { 'Content-Type': data[0].contentType }}
      };
      // 4. PUT阿里云方法
      this.httpRequest(res, option);
    },
    /**
     * 阿里云上传接口
     * @param {*} list 阿里云地址数据
     */
    async httpRequest(list, option) {
      this.isLoadingSuccess = true
      this.uploadingCount++ // 新增上传计数器
      try {
        const resData = await axios.put(list.url, option, list.config);
        if ((resData || {}).status === 200) {
          this.fileListResAll.push({
            ...option,
            ...list,
            ...{ name: option.name }
          });
          if (this.fileListResAll.length + 1 === this.currentLimit) {
            this.$message.success(this.$lang('上传成功'));
          }
        }
        // 2. 响应数据
        this.$emit('uploadSuccess', this.fileListResAll);
      } catch (err) {
        console.log(err)
      } finally {
        if (--this.uploadingCount === 0) {
          this.isLoadingSuccess = false
        }
      }
    },
    /**
     * 文件校验方法
     * @param {*} file 文件地址
     */
    verifyFun(file) {
      // 1. 文件类型
      // const fileType = file.type.split('/')[1]
      const fileType = file.name
        .replace(/[\S\s]+\.(\S+)$/, '$1')
        .toLowerCase();
      // 1.1 判断文件类型可上传性
      const isRtTy =
        !this.fileTypeList.length ||
        this.fileTypeList.includes(fileType);
      // 2. 文件大小
      const isLtRuleSize = file.size / 1024 / 1024 < this.fileSize;
      // 2.1 判断文件大小
      if (!isLtRuleSize) {
        this.$message.error(
          this.$lang('上传大小不能超过' + this.fileSize + 'MB!')
        );
        return false;
      }
      // 2.2 上传数量限制 Ps:没什么用了,已做accept限制,此处二次限制而已
      if (this.currentLimit >= this.limit) {
        this.$message.warning(
          `${this.$lang('最多只能上传')} ${this.limit}${this.$lang(
            '个文件'
          )}`
        );
        return false;
      }
      // 2.3 判断文件类型
      if (!isRtTy) {
        this.$message.warning(
          `${
            this.$lang('只能上传') +
            this.fileTypeList.join(' ') +
            this.$lang('格式')
          }`
        );
        return false;
      }
      // 3. 校验通过
      return true;
    },
    /**
     * 储存文件
     * @param {*} file 文件地址
     */
    fileAdd(file) {
      const reader = new FileReader();
      reader.vue = this;
      reader.readAsDataURL(file);
      reader.onload = function () {
        file.downloadUrl = this.result;
        this.vue.imgList = file;
      };
    },
    /**
     * 删除方法
     * @param {*} index 当前索引
     */
    fileDel(index) {
      this.fileListResAll.splice(index, 1);
      this.currentLimit--;
      // 2. 响应数据
      this.$emit('uploadRemove', this.fileListResAll);
    },
    /**
     * 预览
     * @param {*} index 当前索引
     */
    showImg(data) {
      const list = [];
      this.fileListResAll.forEach((item) => {
        if (item.downloadUrl.match(imgRegularBase)) {
          list.push(item.downloadUrl);
        }
      });
      const index = list.findIndex(
        (item) => item === data.downloadUrl
      );
      this.$openImagePreview(list, index);
    },
    onMouseenter(e) {
      if (!this.uploadTips) return;
      e.preventDefault();
      e.target.focus();
    },
    onMouseleave(e) {
      if (!this.uploadTips) return;
      e.preventDefault();
      e.target.blur();
    },
    onPaste(e) {
      if (!this.uploadTips) return;
      e.preventDefault();
      const cbd = e.clipboardData.files;
      if (cbd.length > 0) {
        for (let i = 0; i < cbd.length; i++) {
          const file = cbd[i];
          this.fileChange({ target: { files: [file] }});
        }
      }
    },
    dragEnter(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    dragOver(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    drop(e) {
      // 当文件拖拽到dropBox区域时,可以在该事件取到files
      e.preventDefault(); // 阻止浏览器默认行为
      e.stopPropagation(); // 阻止事件冒泡
      const cbd = e.dataTransfer.files;
      if (cbd.length > 0) {
        for (let i = 0; i < cbd.length; i++) {
          const file = cbd[i];
          this.fileChange({ target: { files: [file] }});
        }
      }
    }
  },
  destroyed() {
    this.fileListResAll = [];
  }
};
</script>

<style scoped lang="scss">
@mixin upload($type) {
  @each $themename, $theme in $themes {
    [data-theme="#{$themename}"] & {
      @if $type == border {
        border: 1px
          map-get($map: $theme, $key: upload-border-type)
          map-get($map: $theme, $key: upload-border-color);
      } @else if $type == addBg {
        background: map-get($map: $theme, $key: upload-add-bg);
      } @else if $type == rightHover {
        background: map-get($map: $theme, $key: upload-right-hover);
      } @else if $type == rightBorder {
        border: 1px
          solid
          map-get($map: $theme, $key: upload-border-color);
      } @else if $type == rightCloseBg {
        background: map-get(
          $map: $theme,
          $key: upload-right-close-bg
        );
      } @else if $type == fileBg {
        color: map-get($map: $theme, $key: upload-img-fileBg);
      }
    }
  }
}
.img_box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .img_size {
    position: relative;
    width: 100px;
    height: 100px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 5px;
    margin-right: 10px;
    @include border-color("light");
    &:hover {
      .img-mark {
        visibility: visible !important;
      }
    }
    .img-mark {
      position: absolute;
      visibility: hidden;
      width: 100px;
      height: 28px;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      cursor: pointer;
      color: #ffffff;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .add_img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    margin-top: 5px;
    font-size: 18px;
    cursor: pointer;
    font-weight: 600;
    color: #777777;
    border: 1px solid #ddd;
    @include upload("addBg");
    @include border-color("light");
    border-radius: 5px;
  }
  .img_size {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  .icon_size {
    font-size: 30px;
    @include base-color("clr");
  }
  .close {
    height: 14px;
    width: 14px;
    right: -7px;
    position: absolute;
    top: -7px;
    @include upload("rightCloseBg");
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .svg-icon {
      width: 6px;
      height: 6px;
      fill: #ffffff;
    }
    &:hover {
      background: $-color-brand;
    }
  }
}
.uploadTips {
  color: #c4c8cc;
  position: absolute;
  z-index: 0;
  left: 9px;
}
.pathsBorder {
  ::v-deep .img_box {
    margin: 0;
    padding: 4px;
    border-radius: 5px;
    border: 1px solid #dddddd;
    justify-content: flex-end;
  }
}
.loading {
  height: 100px;
  width: 100px;
  border: 1px solid #ddd;
  @include border-color('light');
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 5px;
  margin-right: 5px;
  @include upload('addBg');
  .icon {
    font-size: 40px;
  }
  .l-text {
    @include border-color('light');
    font-size: 12px;
    width: 100%;
    text-align: center;
  }
}
</style>
